import React from "react";
import {Route} from "react-router-dom";
import VentanillaOrderPtmContainer from "../../pages/ventanilla/ptm/VentanillaOrderPtmContainer";
import TodayTradeContainer from "../../pages/ventanilla/trade/TodayTradeContainer";
import VentanillaOrderPttContainer from "../../pages/ventanilla/ptt/VentanillaOrderPttContainer";
import {
    TODAY_TRADE_VENTANILLA_ROUTE,
    VENTANILLA_ORDER_PTM_ROUTE,
    VENTANILLA_ORDER_PTT_ROUTE
} from "../../utils/constants/RoutesConstants";

const VentanillaRoutes = () => {
    return (
        <React.Fragment>
            <Route path={VENTANILLA_ORDER_PTM_ROUTE} component={VentanillaOrderPtmContainer}/>
            <Route path={VENTANILLA_ORDER_PTT_ROUTE} component={VentanillaOrderPttContainer}/>
            <Route path={TODAY_TRADE_VENTANILLA_ROUTE} component={TodayTradeContainer}/>
        </React.Fragment>
    );
};

export default VentanillaRoutes;